<template>
  <div class="centerWidth">
    <div class="tag_position d-flex d-align-center">
      <img src="../assets/images/add1.png" alt="">
      当前位置：<a href="/">首页</a>&gt; <span>我的课程</span>
    </div>
    <div class="new-w9 centerWidth">
      <div class="new-tit2 new-tit d-flex d-just-between d-align-center">
        <div class="tit cur">我的课程</div>
      </div>
      <div class="kecheng_wrap d-flex" >
        <div class="item" v-for="(item,index) in allList" :key="index" :style="{backgroundImage:`url(${item.bg})`}" @click="toKc(item.subject_id,item.name)">
          <div class="top">
            <div>{{ item.name }}</div>
            <div>{{ item.type == 1 ? '视频学习+题库学习' : item.type == 2 ? '视频学习' : '题库学习' }}</div>
            <div>{{ item.studytime }}学时</div>
          </div>
          <div class="bottom">智慧数字化赋能教育考培服务平台</div>
        </div>
      </div>
    </div>

<!--    <div style="text-align: center;padding: 20px 0 20px 0">-->
<!--      <el-pagination-->
<!--          :page-size="10"-->
<!--          :current-page="pageNum"-->
<!--          :background="true"-->
<!--          layout="prev, pager, next"-->
<!--          @current-change="currentChange"-->
<!--          :total="total">-->
<!--      </el-pagination>-->
<!--    </div>-->
  </div>
</template>

<script>
import {
  getcourse
} from "@/api/index";
export default {
  name: "courseList",
  data(){
    return{
      pageNum: 1,
      total: 0,
      allList:[]
    }
  },
  mounted() {
    this.getList()
  },
  methods:{
    getList() {
      getcourse({}).then(res => {
        if (res.code == 1) {
          let allList = []
          res.data.forEach((item)=>{
            allList.push({...item.detail[0],name:item.name,subject_id:item.subject_id})
          })
          allList.forEach((item,index)=>{
            if (Math.floor(index / 4) % 2 === 0) {
              item.bg = localStorage.getItem('first_bg')?localStorage.getItem('first_bg'):'../assets/images/kc_bg1.png'
            }else {
              item.bg = localStorage.getItem('second_bg')?localStorage.getItem('second_bg'):'../assets/images/kc_bg2.png'
            }
          })
          this.allList = allList
          // console.log(allList)
        }
      })
    },
    currentChange(){

    },
    toKc(id,name) {
      let info = JSON.stringify({id:id,name:name})
      this.$router.push({
        path: '/courseDetail',
        query: { info }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.new-main {
  padding: 30px 0;
}
.new-tit-3{
  background: #f6f5f5;
  font-size: 20px;
  font-weight: bold;
  color: #333;
  .line{
    margin-right: 15px;
    width: 5px;
    height: 48px;
    background: #2257ab;
    border-radius: 2px;
  }
}
.new-w9 {
  margin-top: 30px;
  margin-bottom: 30px;
  .kecheng_wrap {
    margin-top: 30px;
    display: flex;
    flex-wrap: wrap;
    .item {
      cursor: pointer;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      height: 180px;
      width: 282px;
      margin-right: 24px;
      margin-bottom: 24px;
      position: relative;

      &:nth-child(4n) {
        margin-right: 0;
      }

      .top {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        color: #ffffff;
        height: 160px;

        div:nth-child(2) {
          margin: 5px 0;
        }
      }

      .bottom {
        font-size: 10px;
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 20px;
        line-height: 20px;
        color: #fff;
        text-align: center;
      }
    }
  }

  .kecheng_wrap_1 {
    .item {
      background-image: url("../assets/images/kc_bg1.png");
    }
  }

  .kecheng_wrap_2 {
    .item {
      background-image: url("../assets/images/kc_bg2.png");
    }
  }
}
</style>
